// extracted by mini-css-extract-plugin
export default {"popper":"styles_popper__D3oFc","popperArrow":"styles_popperArrow__VEsKQ"};